/************
 Product Swiper
 ************/

// setup product swiper
let productImages = new Swiper("#productSwiper");

// thumbnail click
document.querySelectorAll(".productThumbnail").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productImages.slideTo(index);
    });
});

// thumbnail change
productImages.on('slideChange', function (swiper) {
    document.querySelector(".productThumbnail.active").classList.remove("active");
    document.querySelectorAll(".productThumbnail")[swiper.realIndex].classList.add("active");

});


/*****************
 * Product Reviews / FAQ
 * *************/

document.querySelector('#productStars')?.addEventListener("click", function () {
    window.scroll({
        behavior: "smooth",
        top: document.querySelector("#reviews").offsetTop
    });
});
document.querySelector('[href="#reviews"]')?.addEventListener("click", function (e) {
    e.preventDefault();
    window.scroll({
        behavior: "smooth",
        top: document.querySelector("#reviews").offsetTop
    });
});

document.querySelector('[href="#faq"]')?.addEventListener("click", function (e) {
    e.preventDefault();
    window.scroll({
        behavior: "smooth",
        top: document.querySelector(".faq").offsetTop
    });
});

document.querySelector('[href="#hbspt-form"]')?.addEventListener("click", function (e) {
    e.preventDefault();
    window.scroll({
        behavior: "smooth",
        top: document.querySelector(".image-with-text").offsetTop
    });
});

/****************
 * Variant Switcher
 */

// sort dropdown
if (product.vendor === "ANBO") {
    for (let i = 0; i < productOptions.length; i++) {
        productOptions[i].values = productOptions[i].values.sort((a, b) => a.localeCompare(b, 'en', {numeric: true}));
    }
}

// Cache dropdown elements
const productOptionDropdowns = document.querySelectorAll(".productOptionDropdown");

// when a dropdown is changed, run update function
productOptionDropdowns.forEach(function (element) {
    element.addEventListener("change", function () {
        updateProduct();
    });
});

// saved price to skip fetch during bundle updates
let variantQuantityToPrice = {
    // [variantID-quantity]: price
};

//  get real price of variant
async function getFinalPrice(variantID, quantity) {
    // check if price is cached
    if (variantQuantityToPrice[`${variantID}-${quantity}`]) {
        return variantQuantityToPrice[`${variantID}-${quantity}`];
    }

    // unique id
    let uniqueID = new Date().getTime();

    // add the variant to the cart
    let lineItem = await addProduct({
        id: activeVariant.id,
        quantity: quantity,
        properties: {
            "_temp": uniqueID
        }
    });

    // save the price for caching
    variantQuantityToPrice[`${activeVariant.id}-${quantity}`] = lineItem.final_line_price;

    // remove the item from the cart (do not wait)
    changeProduct({
        id: lineItem.key,
        quantity: 0
    });

    return lineItem.final_line_price;
}

// update product
async function updateProduct() {
    // find selected options
    let options = [];
    productOptionDropdowns.forEach(dropdown => options.push(dropdown.value));

    // find new variant based on options
    activeVariant = product.variants.find(variant => {
        return JSON.stringify(variant.options) === JSON.stringify(options);
    });

    // if variant not found, then find a new variant that matches the first option dropdown,
    // this only happens when they change the first dropdown since that's the only way to hit an unavailable variant
    if (!activeVariant) {
        activeVariant = product.variants.find(variant => variant.option1 === options[0]);
    }

    // based on the active variant's first option, find all possible variants that have the same first option
    let possibleVariants = product.variants.filter(variant => variant.option1 === activeVariant.option1);

    // determine allows options for option 2 and 3
    let allowedOptions = {
        "1": [],
        "2": []
    };
    possibleVariants.forEach(variant => {
        allowedOptions["1"].push(variant.option2)
        allowedOptions["2"].push(variant.option3)
    });

    // generate dropdowns
    productOptions.forEach(function (option, index) {
        // save option idnex
        let optionIndex = index;

        // generate HTML
        let HTML = "";

        // generate options
        option.values.forEach(function (value, index) {
            // we don't check the first dropdown AND the option is not allowed
            if (optionIndex !== 0 && !allowedOptions[optionIndex].includes(value)) {
                return;
            }

            // generate option
            HTML += `<option value="${value.replaceAll('"', '&quot;')}" ${activeVariant.options[optionIndex] === value ? "selected" : ""}>${value}</option>`;
        });

        // update options
        document.querySelector(`#productOption${optionIndex}`).innerHTML = HTML;
    });

    // DOM Elements
    const productSKU = document.querySelector("#productSKU span");
    const productWeight = document.querySelector("#productWeight span");
    const productATC = document.querySelector("#productATC");

    // check if variant is not found
    if (!activeVariant) {
        // Mark as not available
        productATC.disabled = true;
        productATC.textContent = `Not Available`;
        return;
    }

    // change image to match variant
    try {
        if (activeVariant.featured_media) {
            productImages.slideTo(activeVariant.featured_media.position - 1);
        }
    } catch (e) {
        // do nothing
    }

    // update meta info
    if (productSKU) productSKU.textContent = activeVariant.sku;
    if (productWeight) productWeight.textContent = `${(activeVariant.weight / 453.6).toFixed(1)} lb`;

    // update price
    if (!activeVariant.available) {
        productATC.disabled = true;
        productATC.textContent = `Sold Out - ${price(activeVariant.price)}`;
        return;
    }

    // enable atc
    productATC.disabled = false;

    // check for bundle
    if (document.querySelector("#productBundles")) {

        // update each bundle item based on the current variant
        for (const element of document.querySelectorAll(".productBundlesItem")) {
            // get discount and quantity metafields
            let discount = parseInt(element.dataset.discount);
            let quantity = parseInt(element.dataset.quantity);
            let badge = element.dataset.badge.toLowerCase();

            // calculate prices
            let originalLinePrice = activeVariant.price * quantity;
            let finalLinePrice = discount === 0 ? originalLinePrice : await getFinalPrice(activeVariant.id, quantity);
            let finalLineSavings = originalLinePrice - finalLinePrice;

            // store compute price as data attribute
            element.dataset.price = finalLinePrice;

            // update fields
            if (finalLineSavings <= 0) {
                element.querySelector(".productBundlesItemBodySave").textContent = "";
                element.querySelector(".productBundlesItemBodyPriceCompare").textContent = "";
            } else {
                element.querySelector(".productBundlesItemBodySave").textContent = `Save ${price(finalLineSavings)}`;
                element.querySelector(".productBundlesItemBodyPriceCompare").textContent = price(originalLinePrice);
            }

            // if the badge is FREE, then we don't show the price
            if (badge === "free") {
                element.querySelector(".productBundlesItemBodyPriceFinal").textContent = "FREE";
            } else {
                element.querySelector(".productBundlesItemBodyPriceFinal").textContent = price(finalLinePrice);
            }
        }

        // find the active bundle item
        let activeBundleItem = document.querySelector(".productBundlesItem.active");

        // update button price
        productATC.textContent = `Add To Cart - ${price(activeBundleItem.dataset.price)}`;

        return;
    }

    // fallback to normal (update button)
    productATC.textContent = `Add To Cart - ${price(activeVariant.price)}`;

}

updateProduct();

/*********************
 Product Bundles
 *********************/

// allow people to switch active bundle item
document.querySelectorAll(".productBundlesItem").forEach(element => {
    element.addEventListener("click", function () {
        // remove active class from all
        document.querySelectorAll(".productBundlesItem").forEach(element => {
            element.classList.remove("active");
        });

        // add active class to this one
        this.classList.add("active");

        // update price
        updateProduct();
    });
})

/**************
 Product ATC
 ***************/

// default quantity
let quantity = 1;

// atc event listener
document.querySelector("#productATC").addEventListener("click", async function () {
    // add loading animation
    document.querySelector("#productATC").classList.add("loading");

    // check for override, bundle
    if (document.querySelector(".productBundlesItem.active")) {
        quantity = parseInt(document.querySelector(".productBundlesItem.active").dataset.quantity);
    }

    let formData = {
        id: activeVariant.id,
        quantity: quantity
    }

    await addProduct(formData);
    await openCart();

    // remove loading animation
    setTimeout(function () {
        document.querySelector("#productATC").classList.remove("loading");
    }, 500);
});


/**************
 Product Tabs
 ***************/

document.querySelectorAll("div.productTab").forEach(function (element) {
    element.addEventListener("click", function () {
        //is this current one open, if so close
        if (this.classList.contains("active")) {
            this.classList.remove("active");
        } else {
            //check if already open
            if (document.querySelector(".productTab.active")) {
                document.querySelector(".productTab.active").classList.remove("active");
            }
            this.classList.add("active");
        }
    });
});

/***********
 * S5icky ATC
 */

// sticky must be enabled
if (document.querySelector("#stickyATC")) {
    // show/hide
    window.addEventListener("scroll", function () {
        if (window.scrollY > document.querySelector("#productATC").offsetTop + document.querySelector("#productATC").offsetHeight) {
            document.querySelector("#stickyATC").classList.add("active");
        } else {
            document.querySelector("#stickyATC").classList.remove("active");
        }
    });

    // click
    document.querySelector("#stickyATC").addEventListener("click", function () {
        window.scroll({
            behavior: "smooth",
            top: document.querySelector("#productTitle").offsetTop
        })
    })
}